import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { components } from "@/client/backend/zz_schema";

interface StatusBadgeProps {
  state: components["schemas"]["AndroidInstanceState"];
}

export function StatusBadge({ state }: StatusBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn("gap-2 rounded-none border-0 bg-transparent px-0 py-0.5 text-xs font-normal", {
        "text-success": state === "ready",
        "text-muted-foreground": state === "terminated",
        "text-warning": state === "unknown",
      })}
    >
      <span aria-hidden className="size-1.5 rounded-full bg-current" />
      {state}
    </Badge>
  );
}
